// 公共方法 按需引入 如import {a} from '@/utils/utils';
const a=()=>{

}

const scrollToFun = () => {
  window.scrollTo({
      top: 0,
      behavior: 'smooth' // 平滑滚动效果
  });
}

const windowFun = () => {
  console.log(window)
  const innerHeight = window.innerHeight
  const innerWidth = window.innerWidth
  return {innerWidth, innerHeight}
}

const isExternal = (path) => {
  return /^(https?:|mailto:|tel:)/.test(path)
}

export{
  a,
  scrollToFun,
  windowFun,
  isExternal
}




// WEBPACK FOOTER //
// ./src/utils/utils.js